module.exports = "/assets/data/8fa287c352635541e797ff8d04a5fc2f-N18.data.json";